// Acadmic Class Service
import AcademicClassTeacherService from "@/core/services/academic-class/class-teacher/AcademicClassTeacherService";
// Academic Year Service
import AcademicYearService from "@/core/services/academicYear/AcademicYearService";
// Program Service
import ProgramService from "@/core/services/level/program/ProgramService";
//grade service
import GradeLevelService from "@/core/services/gradeLevel/GradeLevelService";

const academicClassTeacherService = new AcademicClassTeacherService();
const academicYearService = new AcademicYearService();
const programService = new ProgramService();
const gradeLevelService = new GradeLevelService();

const GeneralMixin = {
    data() {
        return {
            users: [],
            levels: [],
            programs: [],
            academicYears: [],
            gradesLevels: [],
            academic_classes: [],
            zoom_teachers: [],
            assigned_courses:[],
            courses: [],
            loading: false,

        }
    },
    methods: {
        getAssignedTeacherCourses() {
            this.loading = true;
            academicClassTeacherService.getCourseByTeacherId().then(response => {
                let assigned_courses = response.data.courses;
                assigned_courses.forEach(ele => {
                    let gradeTitle = ele.grade.title
                    let course = ele.title
                    ele.display_title = `${gradeTitle} | ${course}`
                    this.assigned_courses.push(ele)
                })

            }).catch((err) => {
                // console.log(err)
            }).finally(() => {
                this.loading = false;

            });
        },
        getAcademicClasses(search = null) {
            academicClassTeacherService.getClasses(search).then(response => {
                this.academic_classes = [];
                let academic_classes = response.data.classes;
                academic_classes.forEach(ele => {
                    let academicYearTitle = (ele.academic_year) ? ele.academic_year.title : null;
                    let levelTitle = (ele.level) ? ele.level.title : null;
                    let programTitle = (ele.program) ? ele.program.title : null;
                    let gradeTitle = (ele.grade) ? ele.grade.title : null;
                    ele.display_title = `${academicYearTitle}  | ${programTitle} | ${gradeTitle} | ${ele.title}`
                    this.academic_classes.push(ele)
                })
                this.loading = false;
            }).catch(err => {
                this.academic_classes = [];
            }).finally(() => {
                this.loading = false;
            });
        },
        getAcademicYears() {
            academicYearService.paginate().then(response => {
                this.academicYears = response.data.data;

            });
        },
        getPrograms() {
            programService.getByTeacher().then(response => {
                this.programs = response.data;
            });
        },
        getGrades() {
            gradeLevelService.getByProgram(this.search.program_id).then(response => {
                this.gradesLevels = response.data;
            });
        },
        getBadge(status_text) {
            if(status_text) {
                status_text = status_text.toLowerCase()
                switch (status_text) {
                    case "completed":
                        return `<span class="badge badge-primary">${status_text.toUpperCase()}</span>`
                    case "result added":
                        return `<span class="badge badge-success">${status_text.toUpperCase()}</span>`
                    case "cancelled":
                        return `<span class="badge badge-danger">${status_text.toUpperCase()}</span>`
                    case "postponed":
                        return `<span class="badge badge-danger">${status_text.toUpperCase()}</span>`
                    default:
                        return `<span class="badge badge-secondary">${status_text.toUpperCase()}</span>`
                }
            }
        }
    },
}
export default {
    install(Vue) {
        Vue.mixin(GeneralMixin)
    }
}